<button type="button" class="btn btn-primary" id="{{modalOpenButtonId}}" [hidden]="true" data-toggle="modal"
  [attr.data-target]="'#' + modalId" data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="{{modalId}}" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="{{modalId}}Title">Developer Access</h5>
        <button type="button" id="{{modalCloseButtonId}}" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [ngStyle]="apiKeys && apiKeys.length > 0 ? '' : {'min-height': '0vh'}">
        <ng-container *ngIf="apiKeys && apiKeys.length > 0 else noApiKey">
          <ng-container *ngFor="let apiKey of apiKeys; let i= index;">
            <div *ngIf="apiKey.appType != 'MOBILE_APP'" class="form-group mb-3">
              <label class="heading" for="vin">API Key for Developer Integration</label>

              <div class="ml-3 mt-1 font13-400"><span class="text-muted">API Key: </span>{{apiKey.apiKey}}</div>
              <div class="ml-3 mt-1 font13-400"><span class="text-muted">Client ID: </span>{{apiKey.clientId}}</div>

              <div *ngIf="secretkeyVisibility[i]" class="ml-3 mt-1 font13-400 w-break"><span class="text-muted">Client
                  Secret: </span>
                <span>{{apiKey.clientSecret}}</span></div>

              <div *ngIf="secretkeyVisibility[i]" class="ml-3 mt-1 font13-400"><span class="text-muted">APP_TYPE: </span>{{apiKey.appType}}</div>

              <button *ngIf="!secretkeyVisibility[i]" class="ml-3 mt-2 btn btn-light-py-0"
                (click)="onClickShowSecretKey(i)">Show
                Detail
              </button>

              <button *ngIf="secretkeyVisibility[i]" class="ml-3 mt-2 btn btn-light-py-0"
                (click)="onClickShowSecretKey(i)">Hide
                Detail
              </button>
            </div>

          </ng-container>
          <label class="font13-600 mt-2">Please use below ids for API Integration</label>
          <div class="ml-3 mt-1 font13-400"><span class="text-muted">OemId: </span>{{apiService.accountDetail.oemId}}</div>
          <div class="ml-3 mt-1 font13-400"><span class="text-muted">AccountId: </span>{{apiService.accountDetail.id}}</div>
        </ng-container>
        <ng-template #noApiKey>
          <div class="text-muted text-center mt-4 mb-4">
            <span>API Keys are not available for this account. <br /><br /></span>
            <span class="error-text"><i>Please contact Support for the API Keys.</i></span>
          </div>
        </ng-template>
      </div>
      <!-- <div class="modal-footer">
      </div> -->
    </div>
  </div>
</div>